import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const AboutStyles = styled.section`
  width: 100vw;
  padding: 60px 0 0 0;
  text-align: center;
  background: white;

  h2 {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-bottom: 30px;
    text-transform: uppercase;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    font-feature-settings: normal;
    font-optical-sizing: auto;
    font-size: 28px;
    font-size-adjust: none;
    font-stretch: 100%;
    font-style: normal;
    font-variant: normal;
    font-variant-alternates: normal;
    font-variant-caps: normal;
    font-variant-east-asian: normal;
    font-variant-ligatures: normal;
    font-variant-numeric: normal;
    font-variant-position: normal;
    font-variation-settings: normal;
    font-weight: 600;
    line-height: 58px;
    margin-bottom: 0px;
    margin-top: 0px;
    outline-style: none;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    text-align: center;
    text-rendering: optimizelegibility;
    vertical-align: baseline;
    -moz-osx-font-smoothing: grayscale;
    color: var(--heading);
  }

  h2:after {
    margin: 0 0 0 20px;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 30px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    /* or 187% */
    letter-spacing: 0.2px;
    color: #2d334a;
    color: #666;
    font-feature-settings: normal;
    font-kerning: auto;
    font-language-override: normal;
    font-optical-sizing: auto;
    font-size: 16px;
    font-size-adjust: none;
    font-stretch: 100%;
    font-style: normal;
    font-variant: normal;
    font-variant-alternates: normal;
    font-variant-caps: normal;
    font-variant-east-asian: normal;
    font-variant-ligatures: normal;
    font-variant-numeric: normal;
    font-variant-position: normal;
    font-variation-settings: normal;
    font-weight: 400;
    line-height: 32px;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default function About({ title, tagline }) {
  return (
    <AboutStyles>
      <div className="container-small">
        <h2>{title || 'Title'}</h2>
        <p>{tagline || 'paragraph'}</p>
      </div>
    </AboutStyles>
  );
}

About.propTypes = {
  title: PropTypes.string,
  tagline: PropTypes.string,
};
